module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "topBar u-wa u-fright"
  }, [_c('div', {
    staticClass: "topBar--item_right"
  }, [_c('router-link', {
    staticClass: "btn btn_blue",
    attrs: {
      "to": "/cities/add"
    }
  }, [_vm._v("\n              Add new city\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table--row table--row_header"
  }, [_c('div', {
    class: _vm.getSortClasses('name'),
    staticStyle: {
      "max-width": "320px"
    },
    on: {
      "click": function($event) {
        _vm.sort('name')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    City\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    class: _vm.getSortClasses('timezone'),
    staticStyle: {
      "max-width": "328px"
    },
    on: {
      "click": function($event) {
        _vm.sort('timezone')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Timezone\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    staticStyle: {
      "max-width": "496px"
    }
  })]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('div', {
      staticClass: "table--row"
    }, [_c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "320px"
      }
    }, [_c('strong', [_vm._v("\n                    " + _vm._s(city.name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "328px"
      }
    }, [_c('strong', [_vm._v("\n                    " + _vm._s(city.timezone) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "96px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn btn_blueLight",
      attrs: {
        "to": {
          name: 'EditCities',
          params: {
            id: city.id
          }
        }
      }
    }, [_vm._v("\n                  Edit\n                ")])], 1)])
  })], 2), _vm._v(" "), (_vm.nextPage) ? _c('a', {
    staticClass: "btn btn_green u-fleft",
    on: {
      "click": function($event) {
        _vm.fetchResource()
      }
    }
  }, [_vm._v("\n        Load more\n    ")]) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row u-wa"
  }, [_c('h1', [_vm._v("\n            Cities\n        ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-67d31d3a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d31d3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cities/Cities.vue
// module id = 444
// module chunks = 1